<template>
  <v-row>
    <v-col cols="12" sm="8">
      <v-fade-transition hide-on-leave>
        <template v-if="loading">
          <v-skeleton-loader class="mx-n4 mt-n4" type="list-item-three-line"/>
        </template>
      </v-fade-transition>
      <v-fade-transition hide-on-leave>
        <template v-if="!loading && tasks.length === 0">
          <div>
            <p>{{ $t('dashboard.start_improving_your_company') }}</p>
            <p>{{ $t('tasks.create_first_task_help') }}</p>
          </div>
        </template>
      </v-fade-transition>
      <v-fade-transition hide-on-leave>
        <template v-if="!loading && tasks.length > 0">
          <div>
            <template v-if="undoneTasksCount > 0 && undoneTasksAssignedToUserCount > 0">
              <p>
                {{
                  $tc('dashboard.company_has_undone_tasks_1', totalTasksCount) + $tc('dashboard.company_has_undone_tasks_2', undoneTasksCount)
                }}</p>
              <p>{{ $tc('dashboard.user_has_undone_tasks', undoneTasksAssignedToUserCount) }}</p>
            </template>
            <template v-if="undoneTasksCount > 0 && undoneTasksAssignedToUserCount === 0">
              <p>
                {{
                  $tc('dashboard.company_has_undone_tasks_1', totalTasksCount) + $tc('dashboard.company_has_undone_tasks_2', undoneTasksCount)
                }}</p>
              <p>{{ $t('dashboard.user_has_done_all_tasks_but_company_has_not') }}</p>
            </template>
            <template v-if="undoneTasksCount === 0 && undoneTasksAssignedToUserCount === 0">
              <p>{{ $t('dashboard.company_has_all_tasks_done') }}</p>
              <p>{{ $t('dashboard.company_has_all_tasks_done_what_next') }}</p>
            </template>
          </div>
        </template>
      </v-fade-transition>
    </v-col>
    <v-col class="fill-height" cols="12" sm="4">
      <v-row align="center" justify="center" no-gutters>
        <div v-if="loading" :class="$vuetify.breakpoint.mdAndUp ? 'mt-n6 mb-n4' : 'mb-4'"
             :style="{width: $vuetify.breakpoint.lgAndUp ? '65%' : '70%'}" style="margin: auto;">
          <v-skeleton-loader type="image"/>
        </div>
        <div v-if="!loading && tasks.length === 0" :class="$vuetify.breakpoint.mdAndUp ? 'mt-n6 mb-n4' : 'mb-4'"
             :style="{width: $vuetify.breakpoint.lgAndUp ? '65%' : '70%'}" style="margin: auto;">
          <v-img src="/img/undraw_maker_launch_re_rq81.svg"/>
        </div>
        <div v-if="!loading && tasks.length > 0 && undoneTasksCount > 0"
             :class="$vuetify.breakpoint.mdAndUp ? 'mt-n6 mb-n4' : 'mb-4'"
             :style="{width: $vuetify.breakpoint.lgAndUp ? '50%' : '70%'}" style="margin: auto;">
          <v-img src="/img/undraw_completed_tasks_vs6q.svg"/>
        </div>
        <div v-if="!loading && tasks.length > 0 && undoneTasksCount === 0"
             :class="$vuetify.breakpoint.mdAndUp ? 'mt-n6 mb-n4' : 'mb-4'"
             :style="{width: $vuetify.breakpoint.lgAndUp ? '60%' : '70%'}" style="margin: auto;">
          <v-img src="/img/undraw_high_five_re_jy71.svg"/>
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import taskApi from "@/api/task";

export default {
  name: "TasksOverview",
  data() {
    return {
      loading: true,
      tasks: [],
    }
  },
  methods: {
    async reloadTasks() {
      this.loading = true;
      try {
        this.tasks = await taskApi.getTasks();
      } catch (error) {
        this.$handleApiError(error, this.$t('errors.error_loading_tasks'));
      }
      this.$emit('refresh');
      this.loading = false;
    },
    getTotalTasksCount() {
      return this.totalTasksCount;
    },
    getUndoneTasksCount() {
      return this.undoneTasksCount;
    }
  },
  computed: {
    totalTasksCount() {
      return this.tasks.length;
    },
    undoneTasksCount() {
      return this.tasks.filter(t => t.status !== 'DONE').length;
    },
    undoneTasksAssignedToUserCount() {
      return this.tasks.filter(t => t.userInCharge?.id === this.$userInfo.id && t.status !== 'DONE').length;
    }
  },
  mounted() {
    this.reloadTasks();
  }
}
</script>

<style scoped>

</style>
